import { createVNode as o, mergeProps as c } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/SuccessOutlined.js";
import n from "../components/PfIcon.js";
const e = (t, r) => {
  const s = {
    ...t,
    ...r.attrs
  };
  return o(n, c(s, {
    icon: i
  }), null);
};
e.displayName = "SuccessOutlined";
e.inheritAttrs = !1;
export {
  e as default
};
